import React from "react";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import dayjs from "dayjs";

const DateButton = React.forwardRef(function DateButton(
  { value, onClick, InputProps },
  _
) {
  return (
    <button type="button" ref={InputProps?.ref} onClick={onClick} className="date-btn">
      <span>{value ? dayjs(value).format("DD MMM YYYY") : "Select Date"}</span>
      <CalendarMonthIcon className="date-btn-icon" />
    </button>
  );
});

export default DateButton;
